import { render, staticRenderFns } from "./InputFontSize.vue?vue&type=template&id=4f50d99e&scoped=true&"
import script from "./InputFontSize.vue?vue&type=script&lang=js&"
export * from "./InputFontSize.vue?vue&type=script&lang=js&"
import style0 from "./InputFontSize.vue?vue&type=style&index=0&id=4f50d99e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f50d99e",
  null
  
)

export default component.exports